import React from 'react';
export function ResultsSection() {
  return <section className="bg-[#F8F6F2] py-20 md:py-28" data-id="element-120">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-121">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-122">
          <span className="text-[#C8A84E] text-sm tracking-[0.2em] uppercase font-semibold mb-4 block" style={{
          fontFamily: "'Montserrat', sans-serif"
        }} data-id="element-123">
            Our Team
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl text-[#1A1A1A] leading-tight" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-124">
            Meet the Raise The Bar Babes
          </h2>
        </div>

        {/* Team Photo */}
        <div className="relative mb-4" data-id="element-125">
          <div className="rounded-2xl overflow-hidden border border-[#C8A84E]/30" data-id="element-126">
            <img src="https://cdn.magicpatterns.com/uploads/eh2s6XTmybE7Z8Ry1ULTw5/raise_the_bar_june_2024-212.jpg" alt="The Raise The Bar Med Spa team — 9 women in matching black branded t-shirts posing together in a bright studio" className="w-full h-auto object-cover" data-id="element-127" />
          </div>
          {/* Gold accent line beneath photo */}
          <div className="mx-auto mt-6 w-[60%] h-[1px] bg-[#C8A84E]/50" data-id="element-128"></div>
        </div>

        {/* Body Text */}
        <p className="text-center text-[#1A1A1A]/80 text-lg max-w-3xl mx-auto mt-8 mb-10 leading-relaxed" style={{
        fontFamily: "'Montserrat', sans-serif"
      }} data-id="element-129">
          Our talented team of licensed professionals is committed to making
          every client feel like family. We never rush — we listen, we care, and
          we deliver results.
        </p>

        {/* CTA */}
        <div className="text-center" data-id="element-130">
          <a href="#book" className="inline-flex items-center justify-center bg-[#C8A84E] hover:bg-[#b39542] text-black px-8 py-4 rounded-full font-semibold transition-all duration-300 transform hover:scale-105 min-h-[48px]" style={{
          fontFamily: "'Montserrat', sans-serif"
        }} data-id="element-131">
            Book With Our Team
          </a>
        </div>
      </div>
    </section>;
}